var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checklist-templates"},[_c('BackButton'),_c('Buttons'),_c('Filters',{on:{"fetching:templates":function($event){_vm.isMakingRequest = $event}}}),_c('TemplateList',{attrs:{"is-fetching":_vm.isMakingRequest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }